import request from './request';

// 获取广告内容
export async function areaDetail(areaCode: string) {
  return request<API.Homepage.Area>(`/api/publicity/areas/${areaCode}`, {
    skipErrorHandler: true,
  });
}

// 获取广告弹窗内容
export async function getPopDetail() {
  return request<API.Homepage.Pop>(`/api/publicity/pop`, {
    skipErrorHandler: true,
  });
}

// 活动列表
export async function listActivities(
  params: API.Homepage.ActivityForListParams,
) {
  return request<API.Homepage.ActivityForList[]>(`/api/activity/activities`, {
    params,
  });
}

// 获取社区表单
export async function listCommunityForms(
  params: API.Homepage.FormForListParams,
) {
  return request<API.PageResponse<API.Homepage.FormForList>>(
    '/api/crf/community/forms',
    { params },
  );
}

/**
 * 贡献排行榜
 * @param statsType
 * portal_rank: 总榜
 * portal_rank_last30d： 月榜
 */
export async function rankForList(params: API.Homepage.RankForListParams) {
  return request<API.ToolPageResponse<API.Homepage.RankForList>>(
    '/api/stats/rank/ranks',
    { params },
  );
}

/**
 * 科研导航-首页展示
 * @returns
 */
export async function navigationForList() {
  return request<API.ToolPageResponse<API.Homepage.NavigationForList>>(
    '/api/tools/navigation/navigations/index',
  );
}

/**
 * 工具广场
 * @returns
 */
export async function toolsForList() {
  return request<API.ToolPageResponse<API.Homepage.ToolForList>>(
    '/api/tools/portal',
  );
}

/**
 * 收藏
 * @param navigationId
 * @returns
 */
export async function navigationBookmark(navigationId: number) {
  return request(`/api/tools/navigation/${navigationId}/like`, {
    method: 'POST',
  });
}

/**
 * 取消收藏
 * @param navigationId
 * @returns
 */
export async function navigationUnbookmark(navigationId: number) {
  return request(`/api/tools/navigation/${navigationId}/unlike`, {
    method: 'POST',
  });
}

/**
 *
 * @returns
 */
export async function getStats() {
  return request<API.Homepage.StatsDetail>('/api/stats/threads/count');
}

// 积分任务列表
export async function listTasks(params: { is_jifen_enabled?: number }) {
  return request<API.Homepage.TaskForList[]>('/api/task/tasks', {
    // 首页会自动调用该接口，用户未登录时屏蔽报错
    // FIXME 注意，原则上，这里不应该设置 skipErrorHandler，而应该在业务组件中判断，若用户未登录，则不调用该接口
    skipErrorHandler: true,
    params,
  });
}

// 触发任务事件通知
export async function taskSignals(data: API.Homepage.TaskCheckSignalsData) {
  return request<API.Homepage.TaskForList[]>('/api/task/signals', {
    method: 'POST',
    data,
  });
}
// 签到
export async function taskCheck(data: API.Homepage.TaskCheckData) {
  return request<API.Homepage.TaskForList[]>('/api/task/check', {
    method: 'POST',
    data,
  });
}
// 用户签到详情
export async function getUsercheck(params: { device_t: number }) {
  return request<API.Homepage.TaskUsercheckDetail>('/api/task/usercheck', {
    params,
    // 首页会自动调用该接口，用户未登录时屏蔽报错
    // FIXME 注意，原则上，这里不应该设置 skipErrorHandler，而应该在业务组件中判断，若用户未登录，则不调用该接口
    skipErrorHandler: true,
  });
}

// 共建积分概要
export async function getBuildingOverview() {
  return request<API.Homepage.BuildingOverviewDetail>(
    '/api/task/building-overview',
  );
}

// 共建榜前10
export async function getBuildingRank(params: { kind: 'all' | 'week' }) {
  return request<API.Homepage.BuildingRankForGet>(
    '/api/task/stat/building-rank',
    { params },
  );
}

// 用户勋章列表
export async function getUserMedal(uid: string | null) {
  return request<API.Homepage.UserMedalForList[]>(
    `/api/task/users/${uid}/user-medal`,
  );
}

// 获取用户完成任务的提示
export async function getUnreadUserTask() {
  return request<API.Homepage.UnreadUserTaskForGet>(
    '/api/task/get-unread-user-task',
  );
}

// 获取用户勋章提示
export async function getUnreadUserMedal() {
  return request<API.Homepage.UnreadUserMedalForGet>(
    '/api/task/get-unread-user-medal',
  );
}

// 最新动态
export async function listEvents(params: API.PageParams) {
  return request<API.ToolPageResponse<API.Homepage.EventForList>>(
    '/api/event/events',
    {
      params,
    },
  );
}

// 获取用户是否有机构工作台
export async function getHasDashboard() {
  return request<API.Homepage.HasJoinedDashboard>(
    '/api/system/userinfo/dashboard',
  );
}
